import worksData from "../assets/works/works.json";
import { Link } from 'react-router-dom';

import { useState } from "react";
import { motion, AnimatePresence } from 'framer-motion';


function Works(){
    const [selectedCategory, setSelectedCategory] = useState("");


    const sortFieldLabel = ["Media", "Installation", "App development"];
    const sortSkillLabel = ["Motion design", "3D design", "Programming"];

    const filterProject = worksData.filter(work => {
        if (!selectedCategory) return work;
        return work.category.some(cat =>
            cat.field.includes(selectedCategory) || cat.skill.includes(selectedCategory)
        );
    });

    const variants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.07, duration: 0.7, ease: "easeOut" },
        }),
    };

    const Archives = () => {
        return (
            <AnimatePresence>
                <div className="archives-container">
                    {filterProject.map((work, index) => (
                        <motion.div
                            key={work.id}
                            className="archive-card-container"
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                            variants={variants}
                            transition={{ duration: 0.7 }}
                            custom={index}
                        >
                            <div>
                                <div>
                                    <div className="archive-mask">
                                        <div className="archive-item" key={work.id}>
                                            <img
                                                src={require(`../assets/works/${work.id}/thumb.jpg`)}
                                                alt={work.title}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="archive-item-hover">
                                    <Link to={`/works/${work.slug}`}
                                        ><div></div>
                                    </Link>
                                    <p>{work.title}</p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </AnimatePresence>
        )
    }

    return (
        <div className="works">
            <div className="works-container">
                <div className="sort-container">
                    <div className="sort-fields-container">
                        <p className="sort-title">- fields</p>
                        <div className="sort-fields">
                            {sortFieldLabel.map((label) => (
                                <p
                                    key={label}
                                    className={selectedCategory === label ? "selected" : ""}
                                    onClick={() => label === selectedCategory ? setSelectedCategory("") : setSelectedCategory(label)}
                                >
                                    {label}
                                </p>  
                            ))}                     
                        </div>
                    </div>
                    <div className="sort-skill-container">
                        <p className="sort-title">- skill</p>
                        <div className="sort-skills">
                            {sortSkillLabel.map((label) => (
                                <p
                                    key={label}
                                    className={selectedCategory === label ? "selected" : ""}
                                    onClick={() => label === selectedCategory ? setSelectedCategory("") : setSelectedCategory(label)}
                                >
                                    {label}
                                </p>  
                            ))}     
                        </div>
                    </div>
                </div>
                <Archives />
            </div>
        </div>
    );
}
export default Works;